export const enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
